import { isRouteOrChildOfRoute } from '@/utils/helpers';
import * as WorkflowNodeService from '@/utils/workflow-node-service';
import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import { BUILDER_TASK_LOG_ROUTE_NAME } from '@/router/router.const';

const buildAnalyticsGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const taskLog = buildAnalyticsGetterObject('taskLog');
export const selectedTaskId = buildAnalyticsGetterObject('selectedTaskId');
export const selectedTaskInfo = buildAnalyticsGetterObject('selectedTaskInfo');
export const selectedNodeRunData = buildAnalyticsGetterObject('selectedNodeRunData');
export const selectedTaskNodes = buildAnalyticsGetterObject('selectedTaskNodes');
export const loadingLogs = buildAnalyticsGetterObject('loadingLogs');
export const loadingSelectedTaskNodes = buildAnalyticsGetterObject('loadingSelectedTaskNodes');
export const useRunsByDay = buildAnalyticsGetterObject('useRunsByDay');
export const useRunsByUser = buildAnalyticsGetterObject('useRunsByUser');
export const useRunsByFeature = buildAnalyticsGetterObject('useRunsByFeature');
export const useLatestErrors = buildAnalyticsGetterObject('useLatestErrors');
export const useIsTaskLogOpen = buildAnalyticsGetterObject('useIsTaskLogOpen');
export const usePersonalInterfacesTaskDetails = buildAnalyticsGetterObject('usePersonalInterfacesTaskDetails');

const getters = {
	[taskLog.getter]: (state) => state.taskLog,
	[selectedTaskId.getter]: (state) => state.selectedTaskId,
	[selectedTaskInfo.getter]: (state) => state.selectedTaskInfo,
	[usePersonalInterfacesTaskDetails.getter]: (state) => (taskId) => state.personalInterfacesTaskLog[taskId],
	[selectedNodeRunData.getter]: (state) => (nodeRunId) => {
		if (state.nodeRunData[nodeRunId]) {
			const nodeRunData = { ...state.nodeRunData[nodeRunId] };
			return Object.assign(nodeRunData, { output: WorkflowNodeService.cleanHiddenFieldsFromNodeOutput(nodeRunData.output) });
		}
		return null;
	},
	[selectedTaskNodes.getter]: (state) => state.selectedTaskNodes,
	[loadingLogs.getter]: (state) => state.loadingLogs,
	[loadingSelectedTaskNodes.getter]: (state) => state.loadingSelectedTaskNodes,
	[useRunsByDay.getter]: (state) => state.runsByDay,
	[useRunsByUser.getter]: (state) => state.runsByUser.sort(sortByMaxRuns),
	[useRunsByFeature.getter]: (state) => state.runsByFeature.sort(sortByMaxRuns),
	[useLatestErrors.getter]: (state) => state.latestErrors.sort((a, b) => new Date(b.date) - new Date(a.date)),
	[useIsTaskLogOpen.getter]: (state, getters) => (currentRoute) =>
		!!getters[selectedTaskId.getter] || isRouteOrChildOfRoute(currentRoute, BUILDER_TASK_LOG_ROUTE_NAME),
};

export default getters;

const sortByMaxRuns = (a, b) => b.runs - a.runs;
